import * as Attendances from './attendances'
import * as ReportCardAudit from './audit'

export default {
  Attendances,
  ReportCardAudit,
}
